var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('views.vouchers.discounts.add.title')))]),_c('DiscountForm',{attrs:{"discount":{}},on:{"form:submit":_vm.submit,"form:cancel":function($event){return _vm.navigate('Vouchers.Discounts')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }